export default function FormCheckbox({ field, value, error, onChange }) {
  // Handle single checkbox
  const handleSingleChange = (e) => {
    onChange(field.name, e.target.checked);
  };

  // Handle multiple checkboxes
  const handleMultipleChange = (optionValue) => {
    const currentValues = Array.isArray(value) ? value : [];
    const newValues = currentValues.includes(optionValue)
      ? currentValues.filter((v) => v !== optionValue)
      : [...currentValues, optionValue];
    onChange(field.name, newValues);
  };

  // Single checkbox (no options provided)
  if (!field.options || field.options.length === 0) {
    return (
      <div className="w-full">
        <label className="flex items-center gap-3 p-3 rounded-lg border-2 cursor-pointer transition-all duration-200 hover:border-aw-bluedark/50">
          <input
            type="checkbox"
            name={field.name}
            checked={!!value}
            onChange={handleSingleChange}
            className="w-5 h-5 accent-aw-bluedark cursor-pointer"
          />
          <span className="text-gray-200 font-medium">
            {field.label}
            {field.required && <span className="text-aw-green font-semibold text-lg ml-1">*</span>}
          </span>
        </label>
        {error && <p className="text-xs text-red-500 mt-2">{error}</p>}
        {field.helpText && !error && (
          <p className="text-xs text-gray-500 mt-2">{field.helpText}</p>
        )}
      </div>
    );
  }

  // Multiple checkboxes (options provided)
  const currentValues = Array.isArray(value) ? value : [];

  return (
    <div className="w-full">
      <label className="block text-sm font-medium text-gray-200 mb-3">
        {field.label}
        {field.required && <span className="text-aw-green font-semibold text-lg ml-1">*</span>}
      </label>
      <div className="space-y-2">
        {field.options.map((option, index) => {
          // Support both string array and object array
          const optionValue = typeof option === "string" ? option : option.value;
          const optionLabel = typeof option === "string" ? option : option.label;
          const isChecked = currentValues.includes(optionValue);

          return (
            <label
              key={index}
              className={`flex items-center gap-3 p-3 rounded-lg border-2 cursor-pointer transition-all duration-200 ${
                isChecked
                  ? "border-aw-green bg-aw-green/5"
                  : "border-gray-300 hover:border-aw-green/50"
              } ${error ? "border-red-500" : ""}`}
            >
              <input
                type="checkbox"
                name={`${field.name}[]`}
                value={optionValue}
                checked={isChecked}
                onChange={() => handleMultipleChange(optionValue)}
                className="w-5 h-5 accent-aw-green cursor-pointer"
              />
              <span className="text-gray-200 font-medium">{optionLabel}</span>
            </label>
          );
        })}
      </div>
      {error && <p className="text-xs text-red-500 mt-2">{error}</p>}
      {field.helpText && !error && (
        <p className="text-xs text-gray-500 mt-2">{field.helpText}</p>
      )}
    </div>
  );
}
